import { render, staticRenderFns } from "./mailing.vue?vue&type=template&id=f7a6f7e6&scoped=true&"
import script from "./mailing.vue?vue&type=script&lang=js&"
export * from "./mailing.vue?vue&type=script&lang=js&"
import style0 from "./mailing.vue?vue&type=style&index=0&id=f7a6f7e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a6f7e6",
  null
  
)

component.options.__file = "mailing.vue"
export default component.exports